import { useState, useEffect, useCallback } from "react";
import api from "../utils/api";

const POLL_MS = 60 * 1000;

export function useNotifications(enabled) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!enabled) return;
    try {
      const { data } = await api.get("/api/notifications");
      setNotifications(data);
    } catch {
      // Silent — a failed notification fetch shouldn't interrupt the rest of the app
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (!enabled) return;
    load();
    const id = setInterval(load, POLL_MS);
    return () => clearInterval(id);
  }, [enabled, load]);

  async function markRead(id) {
    setNotifications(prev => prev.map(n => (n.id === id ? { ...n, isRead: true } : n)));
    try { await api.post(`/api/notifications/${id}/read`); } catch { /* best-effort */ }
  }

  async function markAllRead() {
    setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
    try { await api.post("/api/notifications/read-all"); } catch { /* best-effort */ }
  }

  const unreadCount = notifications.filter(n => !n.isRead).length;

  return { notifications, loading, unreadCount, markRead, markAllRead, reload: load };
}
